import { render, staticRenderFns } from "./AdminCategoryForm.vue?vue&type=template&id=281ac8d8"
import script from "./AdminCategoryForm.vue?vue&type=script&lang=js"
export * from "./AdminCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports